import { useEffect, useState } from "react";
import Modal from "../../../componentes/modal/modal";
import Button from "../../../componentes/button/button";
import FortesFiscalService from "../../../services/resource/fortesFiscalService";
import { formatarData } from "../../../utils/solicitacoes/formatters";
import Campo from "./Campo";

const fortesFiscalService = new FortesFiscalService();

/**
 * Dados do funcionário consultados ao vivo no Fortes (EPG/SEP/HEPG) — usado no processo de
 * Desligamento. `funcionarioId` controla a busca (muda -> refaz); `isOpen` só controla a
 * visibilidade do modal.
 */
export default function DadosFortesDesligamentoModal({ isOpen, funcionarioId, onClose }) {
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(false);
    const [dados, setDados] = useState(null);

    useEffect(() => {
        if (!isOpen || !funcionarioId) return undefined;

        setCarregando(true);
        setErro(false);
        setDados(null);

        let cancelado = false;
        fortesFiscalService.buscarDadosDesligamento(funcionarioId)
            .then(res => {
                if (cancelado) return;
                const lista = res.data || [];
                setDados(lista.length > 0 ? lista[0] : null);
            })
            .catch(() => {
                if (!cancelado) setErro(true);
            })
            .finally(() => {
                if (!cancelado) setCarregando(false);
            });

        return () => { cancelado = true; };
    }, [isOpen, funcionarioId]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Dados do Fortes"
            subtitle="Dados consultados ao vivo no Fortes"
            className="w-[95%] max-w-4xl"
            footer={
                <div className="flex justify-end">
                    <Button variant="outline" label="Fechar" onClick={onClose} />
                </div>
            }
        >
            <div className="p-4 min-h-[10rem]">
                {carregando && (
                    <div className="flex items-center justify-center py-10 text-sm text-muted-foreground">
                        <i className="fa fa-spinner fa-spin mr-2" /> Buscando dados no Fortes...
                    </div>
                )}

                {!carregando && erro && (
                    <div className="flex flex-col items-center gap-2 py-10 text-center">
                        <i className="fa fa-exclamation-triangle text-destructive text-xl" />
                        <p className="text-sm text-foreground">Erro ao consultar os dados no Fortes.</p>
                        <p className="text-xs text-muted-foreground">Tente novamente em instantes.</p>
                    </div>
                )}

                {!carregando && !erro && !dados && (
                    <div className="flex flex-col items-center gap-2 py-10 text-center">
                        <i className="fa fa-id-card text-muted-foreground text-xl" />
                        <p className="text-sm text-foreground">Funcionário não encontrado no Fortes.</p>
                    </div>
                )}

                {!carregando && !erro && dados && (
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm">
                        <Campo label="Código do Funcionário" valor={dados.codigoFuncionario} />
                        <Campo label="Nome completo" valor={dados.nome} />
                        <Campo label="Data de Nascimento" valor={formatarData(dados.dataNascimento)} />
                        <Campo label="Data de Admissão" valor={formatarData(dados.dataAdmissao)} />
                        <Campo label="Último Exame Médico" valor={formatarData(dados.dataUltimoExameMedico)} />
                        <Campo label="Data de Rescisão" valor={formatarData(dados.dataRescisao)} />
                        <Campo label="Previsão de Férias" valor={formatarData(dados.dataPrevisaoFerias)} />
                        <Campo label="Pertence à CIPA" valor={dados.cipa ? "Sim" : "Não"} />
                    </div>
                )}
            </div>
        </Modal>
    );
}